/**
 * @generated SignedSource<<74e7a485a99ce4bcef1c8204fc5e15f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespMarketplacePersonalizedCarouselLazy_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedPersonalizationCarousel_user">;
  readonly " $fragmentType": "PdpRespMarketplacePersonalizedCarouselLazy_user";
};
export type PdpRespMarketplacePersonalizedCarouselLazy_user$key = {
  readonly " $data"?: PdpRespMarketplacePersonalizedCarouselLazy_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplacePersonalizedCarouselLazy_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespMarketplacePersonalizedCarouselLazy_user",
  "selections": [
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedPersonalizationCarousel_user"
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "8416fc2d50eabf5e0302fecb9e35014d";

export default node;
